import { Language } from '../entities/language';
import { Zone } from '../entities/zone';

export abstract class ZoneRepository {
  abstract findAll(language: Language): Promise<readonly Zone[]>;
}
